import React from "react";
import GoBack from "../../../components/GoBack";
import { MdNotifications } from "react-icons/md";
import ItemsTab from "../../../components/itemstab";
import { Role, useGetWalletQuery } from "../../../generated/graphql";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

const Balance = () => {
  const { data: walletData } = useGetWalletQuery({
    fetchPolicy: "cache-and-network",
  });

  const loggedInRole = useSelector(
    (state: RootState) => state.loggedInUser.role
  );

  return (
    <div className="pt-10">
      <div className="px-4 relative">
        <div className="flex items-center">
          <GoBack />
          <button className="ml-auto">
            <MdNotifications className="text-xl" />
          </button>
        </div>

        <section className="my-6">
          <div className="text-center mb-4">
            <p className="text-[10px] text-[#0D5AD9] mb-1">
              Total Wallet Balance
            </p>
            <p className="text-[#0D5AD9] text-[21px] font-bold">
              {walletData?.getWallet && walletData.getWallet?.balance} AFYA
            </p>
          </div>

          <div className="text[#1A222F] font-normal text-base px-2 leading-6 mb-6">
            This is the breakdown of your total wallet balance across all
            profiles.
          </div>

          <div>
            <ItemsTab
              className="ring-1 ring-gray-300 !py-4 !px-0 mb-2 text-left"
              leading={undefined}
              trailing={undefined}
            >
              <div className="text-[#1A222F] flex justify-between dark:text-white">
                <p className="text-md font-normal max-w-[109px]">
                  Total balance from point of care activities
                </p>

                <div className="text-right">
                  <p className="font-medium">
                    {loggedInRole === Role.Patient
                      ? walletData?.getWallet?.patient?.interaction
                      : loggedInRole === Role.Chw
                      ? walletData?.getWallet?.chw?.interaction
                      : loggedInRole === Role.Practitioner
                      ? walletData?.getWallet?.practitioner?.interaction
                      : 0}{" "}
                    AFYA
                  </p>
                  <p>R20</p>
                </div>
              </div>
            </ItemsTab>

            <ItemsTab
              className="ring-1 ring-gray-300 !py-4 !px-0 mb-2 text-left"
              leading={undefined}
              trailing={undefined}
            >
              <div className="text-[#1A222F] flex justify-between dark:text-white">
                <p className="text-md font-normal max-w-[109px]">
                  Total balance from questionnaires
                </p>

                <div className="text-right">
                  <p className="font-medium">
                    {loggedInRole === Role.Patient
                      ? walletData?.getWallet?.patient?.task
                      : loggedInRole === Role.Chw
                      ? walletData?.getWallet?.chw?.task
                      : loggedInRole === Role.Practitioner
                      ? walletData?.getWallet?.practitioner?.task
                      : 0}{" "}
                    AFYA
                  </p>
                  <p>R20</p>
                </div>
              </div>
            </ItemsTab>

            <ItemsTab
              className="ring-1 ring-gray-300 !py-4 !px-0 text-left"
              leading={undefined}
              trailing={undefined}
            >
              <div className="text-[#1A222F] flex justify-between dark:text-white">
                <p className="text-md font-normal max-w-[134px]">
                  Total balance from received transactions
                </p>

                <div className="text-right">
                  <p className="font-medium">
                    {walletData?.getWallet?.received} AFYA
                  </p>
                  <p>R20</p>
                </div>
              </div>
            </ItemsTab>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Balance;
